import PropTypes from "prop-types";
import React, { useContext } from "react";

import { classNames } from "@swa-ui/string";

import "../../generated/platforms/scss/customer-dark.module.scss";
import "../../generated/platforms/scss/customer-light.module.scss";
import "../../generated/platforms/scss/customer.module.scss";
import { DesignTokensThemeContext, DesignTokensThemeProvider } from "../DesignTokensThemeProvider";

/**
 * Default customer theme.
 */

export const CustomerTheme = (props) => {
  const { children } = props;
  const { isDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  return <DesignTokensThemeProvider {...getProps()}>{children}</DesignTokensThemeProvider>;

  function getProps() {
    return {
      className: classNames(
        isDarkMode ? "customer-dark-theme" : "customer-light-theme",
        "customer-theme"
      ),
      inverse: false,
      themeName: "customer",
    };
  }
};

CustomerTheme.propTypes = {
  /** Content that will be rendered within the theme. */
  children: PropTypes.node,
};
